import { HttpErrorResponse } from "@angular/common/http";
import { throwError } from "rxjs";

export class CommonUtils {

    public static errorHandler(error: HttpErrorResponse) {
        return throwError("server error: " + error.message);
    }

    public static containsParam(params:any, value:any,key:string ) {
        if (this.isEmpty(value)) {
            params[key] = value
        }
        return params
    }

    public static isNotNullOrUndefined(value:any ) {
        if (value!==undefined && value !==null) {
            return true;
        }
        return false;
    }

    public static formatDate(d: Date | string): string {
        const date = d instanceof Date ? d : new Date(d);
        return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
    }

      public static isEmpty(value:any ) {
        if (value!==undefined && value !==null && value !== '') {
            return true;
        }
        return false;
    }
}
